import React from "react";
import { EnvironmentHelper, MessageInterface } from "../../helpers";
import { DisplayBox, } from "../../components"


interface Props {
  message?: MessageInterface,
}

export const MessagePreview: React.FC<Props> = props => {

  function getIframe() {
    let result = <></>
    if (!props.message) return result;
    const holder = document.getElementById('previewHolder');
    if (holder) {
      let screenWidth = 1920.0;
      let screenHeight = 1080.0;
      if (props.message?.shape === "9:16") {
        screenWidth = 1080.0;
        screenHeight = 1920.0;
      }

      let percent = holder.clientWidth / screenWidth;
      if (props.message?.shape === "9:16") {
        screenWidth = 1080.0;
        screenHeight = 1920.0;
        percent = holder.clientWidth / screenWidth / 2;
      } else if (props.message?.shape === "4:1") {
        screenWidth = 1920.0;
        screenHeight = 480.0;
        percent = holder.clientWidth / screenWidth;
      }



      const leftOffset = screenWidth * (1.0 - percent) / 2.0;
      const topOffset = screenHeight * (1.0 - percent) / 2.0;

      const previewUrl = EnvironmentHelper.PlayerRoot + "/preview?messageId=" + props.message?.id;
      const style: React.CSSProperties = {
        width: screenWidth,
        marginLeft: -leftOffset,
        marginRight: -leftOffset,
        height: screenHeight,
        marginTop: -topOffset,
        marginBottom: -topOffset,
        border: 0,
        transform: "scale(" + percent.toString() + ")"
      }
      result = <iframe id="previewFrame" src={previewUrl} style={style} scrolling="no" title="Message Preview"></iframe>;
    }
    return result;
  }

  return (
    <DisplayBox headerIcon="far fa-image" headerText="Preview" >
      <div id="previewHolder"  >
        {getIframe()}
      </div>
    </DisplayBox>
  );
}
